export class ActivityModel {
  type: ActivityType;
  date: Date;
  id?: number;
  profileImg?: string;
  fullname?: string;
  city?: string;
  taskname?: string;

  constructor(object: Partial<ActivityModel>) {
    Object.assign(this, object);
  }
}

export enum ActivityType {
  NEW_USER = 'NEW_USER',
  NEW_HH = 'NEW_HH',
  NEW_TASK = 'task-created',
  NEW_BID = 'offer-created',
  TASK_COMPLETED = 'task-completed',
  TASK_ACCEPTED = 'offer-accepted',
  HH_UPDATED = 'user-updated',
  NEW_REVIEW = 'review-created', // 5 stars only
  HH_VISITED = 'HH_VISITED',
  NEW_OFFER_COM = 'offer-comment-created',
  NEW_TASK_COM = 'task-comment-created',
  NEW_PAYMENT = 'NEW_PAYMENT',
}
